/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Managepaymentmethod2Inputs */

const en_managepaymentmethod2 = /** @type {(inputs: Managepaymentmethod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage payment details`)
};

const de_managepaymentmethod2 = /** @type {(inputs: Managepaymentmethod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsdaten verwalten`)
};

/**
* | output |
* | --- |
* | "Manage payment details" |
*
* @param {Managepaymentmethod2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const managepaymentmethod2 = /** @type {((inputs?: Managepaymentmethod2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Managepaymentmethod2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_managepaymentmethod2(inputs)
	return de_managepaymentmethod2(inputs)
});
export { managepaymentmethod2 as "managePaymentMethod" }